import classNames from 'classnames';
import { IconProps } from '.';

export const SearchIcon = ({ className, color }: IconProps) => {
  return (
    <svg
      className={classNames(className)}
      width='19'
      height='18'
      viewBox='0 0 19 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M13.5 7.5C13.5 10.8137 10.8137 13.5 7.5 13.5C4.18629 13.5 1.5 10.8137 1.5 7.5C1.5 4.18629 4.18629 1.5 7.5 1.5C10.8137 1.5 13.5 4.18629 13.5 7.5ZM12.2465 13.3072C10.9536 14.3652 9.30095 15 7.5 15C3.35786 15 0 11.6421 0 7.5C0 3.35786 3.35786 0 7.5 0C11.6421 0 15 3.35786 15 7.5C15 9.30095 14.3652 10.9536 13.3072 12.2465L17.7803 16.7197C18.0732 17.0126 18.0732 17.4874 17.7803 17.7803C17.4874 18.0732 17.0126 18.0732 16.7197 17.7803L12.2465 13.3072Z'
        fill={color ?? 'black'}
      />
    </svg>
  );
};

export const SearchIconV2 = ({ className, color = 'currentColor' }: IconProps) => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <circle cx='6.5' cy='6.5' r='5.25' stroke={color} strokeWidth='1.5' />
      <path
        d='M12.9393 15.0607C13.5251 15.6464 14.4749 15.6464 15.0607 15.0607C15.6464 14.4749 15.6464 13.5251 15.0607 12.9393L12.9393 15.0607ZM14 14L15.0607 12.9393L12.8107 10.6893L11.75 11.75L10.6893 12.8107L12.9393 15.0607L14 14Z'
        fill={color}
      />
    </svg>
  );
};

export const VisualSearchIcon = ({ className, color = 'currentColor' }: IconProps) => {
  return (
    <svg
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <circle cx='9' cy='9' r='3.75' stroke={color} strokeWidth='1.5' />
      <path
        d='M13.9393 16.0607C14.5251 16.6464 15.4749 16.6464 16.0607 16.0607C16.6464 15.4749 16.6464 14.5251 16.0607 13.9393L15 15L13.9393 16.0607ZM15 15L16.0607 13.9393L13.8107 11.6893L12.75 12.75L11.6893 13.8107L13.9393 16.0607L15 15Z'
        fill={color}
      />
      <path opacity='0.5' d='M1.5 6.75V4.5C1.5 2.84315 2.84315 1.5 4.5 1.5H6.75' stroke={color} strokeWidth='1.5' />
      <path opacity='0.5' d='M1.5 11.25V13.5C1.5 15.1569 2.84315 16.5 4.5 16.5H6.75' stroke={color} strokeWidth='1.5' />
      <path opacity='0.5' d='M16.5 6.75V4.5C16.5 2.84315 15.1569 1.5 13.5 1.5H11.25' stroke={color} strokeWidth='1.5' />
    </svg>
  );
};
